import api from "./api";
import moment from "moment";

const today = () => moment().format("YYYY-MM-DD");

const dateRange = (debut, fin) => ({
  date_debut: debut ?? today(),
  date_fin: fin ?? today(),
});

export const getEvdStats = (debut, fin) =>
  api.post("/dashboard-evd-stats", dateRange(debut, fin));

export const getApproStats = (debut, fin) =>
  api.post("/dashboard-appro-stats", dateRange(debut, fin));

export const getTopPos = (debut, fin) =>
  api.post("/dashboard-toppos-stats", dateRange(debut, fin));

export const getCommerciauxRepartition = (debut, fin) =>
  api.post("/dashboard-commerciauxrepartition-stats", dateRange(debut, fin));

export const getVenteByYear = () =>
  api.get("/stat_vente_by_year");

export const getDailyStats = (debut, fin) =>
  api.post("/dashboard-daily-stats", dateRange(debut, fin));

export const importDailyFile = (formData) =>
  api.post("/import-daily-file", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const importDailyDeleteFile = (formData) =>
  api.post("/import-daily-delete-file", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
